import React from 'react';
import { createSelector } from 'reselect';

import type { RootState } from 'config/store/reducers';
import { getEntity } from 'modules/entity/selectors';

const getState = (state: RootState) => state.customers;

const getData = createSelector(getState, (state) => state.data);

export const getUI = createSelector(getState, (state) => state.ui);

const getAll = createSelector(getData, (data) => data.byId);

const getSelectedId = createSelector(getUI, (ui) => ui.selectedCustomerId);

const getSelectedCustomer = createSelector(getSelectedId, getAll, (id, customers) => (id ? customers[id] : undefined));

export const getSelectedCustomerLanguage = createSelector(getSelectedCustomer, (customer) => customer?.language);

export const getUserGreetingMessageDescriptor = createSelector(getEntity, ({ customerInfo = {} }) => {
  const { civility, companyName, firstName, lastName } = customerInfo;
  return {
    id: 'civility.greetings',
    defaultMessage: 'Dear Sir or Madam',
    values: {
      civility: civility?.toLowerCase(),
      lastName,
      firstName,
      companyName,
      hasFirstName: Boolean(firstName),
      br: <br />,
    },
  };
});
